<template>
  <div
    v-if="
      !productStore.decoratedProduct?.isDiscontinued &&
      (store.items.length > 0 || displayCoPilot)
    "
    class="product-variant-picker"
  >
    <div
      v-if="$textDictionary['pdp.crossselling-addons.title.label']"
      class="product-variant-picker__title"
    >
      <span>
        {{ $textDictionary['pdp.crossselling-addons.title.label'] }}
      </span>
    </div>
    <div
      v-if="
        store.items.length > 0 ||
        productStore.decoratedProduct?.isInLensSelector
      "
      class="product-variant-picker__items"
    >
      <div v-if="displayCoPilot" class="product-variant-picker__item">
        <ProductDetailCoPilot />
      </div>
      <div
        v-for="item in store.items"
        :key="item.id"
        class="product-variant-picker__item"
      >
        <ProductVariantPickerSelect
          v-bind="item"
          @update:model-value="
            (value) => store.selectCrossSellingProduct(item.id, value)
          "
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProductVariantPickerSelect } from '@hypercodestudio/basler-components';
import { useCrossSellingProductsStore } from '~/stores/productDetailPageStore/crossSellingProductsStore';
import ProductDetailCoPilot from '~/components/shop/ProductDetailCoPilot.vue';
import { useProductDetailPageStore } from '~/stores/productDetailPageStore/productDetailPageStore';

const { $textDictionary, $shopStore, $analytics } = useNuxtApp();
const store = useCrossSellingProductsStore();
const productStore = useProductDetailPageStore();

// TODO: USE GLOBAL CONSTANTS FOR THIS OR BETTER MAKE IT CONFIGURABLE?
const ALLOWED_COPILOT_STORES = ['emea_de', 'emea_en', 'amer_en', 'apac_en'];
const FORBIDDEN_COPILOT_PRODUCT_FAMILIES = ['dart M'];
const FORBIDDEN_COPILOT_PRODUCT_LINES = ['ace 2 R with IP67'];

const displayCoPilot = computed(
  () =>
    productStore.decoratedProduct?.isInLensSelector &&
    !productStore.decoratedProduct?.accessoryCategory &&
    ALLOWED_COPILOT_STORES.includes($shopStore.value) &&
    productStore.decoratedProduct?.familyLabel &&
    !FORBIDDEN_COPILOT_PRODUCT_FAMILIES.includes(
      productStore.decoratedProduct?.familyLabel
    ) &&
    productStore.decoratedProduct?.productLine &&
    !FORBIDDEN_COPILOT_PRODUCT_LINES.includes(
      productStore.decoratedProduct?.productLine
    )
);

onMounted(() => {
  if (
    !productStore.decoratedProduct?.isDiscontinued &&
    store.items.length > 0
  ) {
    $analytics.pushToDataLayer({
      action: 'show_recommended_accessories',
      category: 'recommended_accessories',
      event: 'customEvent'
    });
  }
  if (displayCoPilot.value) {
    $analytics.pushToDataLayer({
      action: 'show_recommended_copilens',
      category: 'recommended_copilens',
      event: 'customEvent'
    });
  }
});
</script>
